export const CONFIG = Object.freeze({
  appVersion: '3.0.0-alpha.4',
  profileDefault: 'screen-mono',
  camera: Object.freeze({
    width: 1280,
    height: 720,
    requestedFps: 60,
    scanWidth: 720,
    scanIntervalMs: 100,
    dedupeReleaseMs: 1500,
    fpsProbeMs: 2200,
  }),
  qr: Object.freeze({
    errorCorrectionLevel: 'Q',
    marginModules: 4,
    palette: 'mono',
    tokenChars: 16,
    tokenHoldMs: 900,
    tokenMinimumDisplayMs: 320,
    ackTimeoutMs: 4000,
    ackDisplayMs: 4500,
    stopAfterDeliveryMs: 1000,
    udpRepeats: 2,
    maxPacketAttempts: 4,
    transferIdleMs: 45_000,
    maxActiveTransfers: 4,
  }),
  torch: Object.freeze({
    minimumChipMs: 80,
    maximumChipMs: 600,
    toggleSafetyFactor: 1.6,
    receiverFramesPerChip: 3,
  }),
  diagnosticsLimit: 300,
});

export function stableDeviceId(storage = localStorage, cryptoApi = crypto) {
  const existing = Number.parseInt(storage.getItem('lumichat.deviceId') || '', 10);
  if (Number.isInteger(existing) && existing >= 1 && existing <= 0xfffe) return existing;
  const bytes = new Uint16Array(1);
  cryptoApi.getRandomValues(bytes);
  const value = (bytes[0] % 0xfffe) + 1;
  storage.setItem('lumichat.deviceId', String(value));
  return value;
}
